import { _$lineGroup, _$editMarkerGroup, _$viewMarkerGroup, } from "../route-service/event-handler-groups";
import { _attachLengthDisplay, _removeLengthDisplay, } from "../route-service/route-length";
import { _registerRoute, _unregisterRoute, } from '../route-service/route-registry';
import { _deselectRoute, } from '../route-service/select-route';
const _u_addRoute = (route) => {
    let currentPoint = route.s();
    while (true) {
        currentPoint.m().addTo(_$editMarkerGroup);
        const outgoingLine = currentPoint.ol();
        if (!outgoingLine) {
            break;
        }
        outgoingLine.ml().addTo(_$lineGroup);
        const nextPoint = currentPoint.np();
        if (!nextPoint) {
            break;
        }
        currentPoint = nextPoint;
    }
    _finishAddingRoute(route);
    return route;
}, _u_removeRoute = (route) => {
    let currentPoint = route.s();
    while (true) {
        currentPoint.m().removeFrom(_$editMarkerGroup);
        const outgoingLine = currentPoint.ol();
        if (!outgoingLine) {
            break;
        }
        outgoingLine.ml().removeFrom(_$lineGroup);
        const nextPoint = currentPoint.np();
        if (!nextPoint) {
            break;
        }
        currentPoint = nextPoint;
    }
    _finishRemovingRoute(route);
    return route;
}, _u_addMultipleRoutes = (routes) => {
    for (const route of routes) {
        _u_addRoute(route);
    }
}, _u_removeMultipleRoutes = (routes) => {
    for (const route of routes) {
        _u_removeRoute(route);
    }
}, _u_replaceRoute = ({ o: existingRoute, n: newRoute, }) => {
    _u_removeRoute(existingRoute);
    _u_addRoute(newRoute);
}, _u_replaceNewRouteWithOld = ({ o: oldRoute, n: currentRoute, }) => _u_replaceRoute({
    o: currentRoute,
    n: oldRoute,
}), _u_replaceRoutes = ({ o: existingRoutes, n: newRoutes, }) => {
    _u_removeMultipleRoutes(existingRoutes);
    _u_addMultipleRoutes(newRoutes);
}, _u_replaceNewRoutesWithOld = ({ o: oldRoutes, n: currentRoutes, }) => _u_replaceRoutes({
    o: currentRoutes,
    n: oldRoutes,
}), _finishAddingRoute = (route) => {
    route.sv().addTo(_$viewMarkerGroup);
    route.ev().addTo(_$viewMarkerGroup);
    _registerRoute(route);
    _attachLengthDisplay(route);
}, _finishRemovingRoute = (route) => {
    _deselectRoute(route);
    route.sv().removeFrom(_$viewMarkerGroup);
    route.ev().removeFrom(_$viewMarkerGroup);
    _unregisterRoute(route);
    _removeLengthDisplay(route);
}, _u_cutRoute = ({ f: firstRoute, s: secondRoute, o: overallRoute, }) => {
    _u_removeRoute(overallRoute);
    _u_addRoute(firstRoute);
    _u_addRoute(secondRoute);
}, _u_joinRoutes = ({ f: firstRoute, s: secondRoute, o: overallRoute, }) => {
    _u_removeRoute(firstRoute);
    _u_removeRoute(secondRoute);
    _u_addRoute(overallRoute);
};
export { _u_addRoute, _u_removeRoute, _u_addMultipleRoutes, _u_removeMultipleRoutes, _u_replaceRoute, _u_replaceNewRouteWithOld, _u_replaceRoutes, _u_replaceNewRoutesWithOld, _u_cutRoute, _u_joinRoutes, };
